module.exports = __webpack_public_path__ + "img/tj-title.35f340f7.png";